import React, { useMemo } from 'react';
import { OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap';
import { Star } from 'lucide-react';
import { isStaff } from '../../../helpers/global';

const OrderPinToggle = ({ order, disabled, isPinning, onTogglePin }) => {
  const role = useMemo(() => localStorage.getItem('user-role'), []);

  if (!isStaff(role) || !order?._id) return null;

  const isDisabled = disabled || isPinning;

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={`pin-order-${order._id}`}>
          {order.pinned ? 'Unpin order' : 'Pin order'}
        </Tooltip>
      }
    >
      <span className="d-inline-flex align-items-center mr-2">
        {isPinning ? (
          <Spinner
            animation="border"
            size="sm"
            role="status"
            style={{ width: 20, height: 20, borderWidth: 2 }}
          />
        ) : (
          <Star
            size={20}
            fill={order.pinned ? '#F5A623' : 'none'}
            color={order.pinned ? '#F5A623' : '#9CA3AF'}
            className="flex-shrink-0"
            style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
            onClick={e => {
              e.stopPropagation();
              if (isDisabled) return;
              onTogglePin?.(order);
            }}
          />
        )}
      </span>
    </OverlayTrigger>
  );
};

export default OrderPinToggle;
